 /** returns Batchfile Transfers list
@return { Array }
*/
export const getBatchfileTransfersList = state => state.batchfileTransferList

/** returns BatchFileTransfer hasMore value
@return { Boolean }
*/
export const getBatchfileTransferHasMore = state => state.batchFileTransferHasMore

/** returns status list
@return { Array }
*/
export const getStatusList = state => state.statusList
